<script>
  import { t } from 'precompile-intl-runtime';
  import { onMount } from 'svelte';
  import ui from 'stores/UI';
  import Subcomponents from './Subcomponents';
  import BackIcon from 'icons/back.svg';

  let dialogElement;
  $: selectedMenu = $ui.selectedMenu;

  $: {
    console.log('selected menu', selectedMenu);
  }

  onMount(() => {
    document.body.addEventListener('pointerdown', onClick);
  });

  function onClick(event) {
    if (dialogElement === null) {
      document.body.removeEventListener('pointerdown', onClick);
      return;
    }
    if (
      selectedMenu !== -1 &&
      //Disable click dismissal for select/repeat
      selectedMenu !== 3 &&
      !dialogElement.contains(event.target) &&
      !event.target.classList.contains('color-input-canvas')
    ) {
      event.preventDefault();
      ui.update((temp) => {
        temp.selectedMenu = -1;
      });
      document.body.removeEventListener('pointerdown', onClick);
    }
  }

  function close() {
    ui.update((temp) => {
      temp.selectedMenu = -1;
    });
  }
</script>

{#if selectedMenu !== -1}
  <div class="dialog" bind:this={dialogElement}>
    <div class="header">
      <button on:click={() => close()}>{@html BackIcon}</button>
      <h2>{$t(`page.${Subcomponents[selectedMenu].name}.title`)}</h2>
    </div>
    <svelte:component this={Subcomponents[selectedMenu].component} />
  </div>
{/if}

<style>
  @media (min-width: 900px) {
    .dialog {
    }
  }

  @media (max-width: 900px) {
    .dialog {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .dialog {
    position: absolute;
    overflow: auto;

    z-index: 10;
    background-color: var(--color-5);
    padding: 20px;
    border: 1px solid var(--color-4);

    max-width: calc(100vw - 20px * 2);
  }

  .header button {
    margin: 0;
    margin-right: 8px;
    width: 30px;
    height: 30px;
    background: none;
    padding: 0;
    fill: #333;
    stroke: #333;
  }

  .header button:hover {
    border: 0;
    fill: var(--color-1);
  }

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .header h2 {
    flex-grow: 1;
    text-align: center;
    margin: 0;
  }
</style>
